
var testimonial_sliders = document.querySelectorAll('.testimonial-slider');

function updateSliderCount(target, slider){

    target.querySelector('.max_amount').innerHTML = slider.slides.length
    target.querySelector('.current_amount').innerHTML = slider.selectedIndex + 1;

    slider.on( 'change', function( index ) {
        target.querySelector('.current_amount').innerHTML = slider.selectedIndex + 1;
    });

}

testimonial_sliders.forEach(function(slider) {
    // Now do something with my button
    var current_slider = slider.querySelectorAll('.testimonial-slider__container')
    var flkty = new Flickity(current_slider[0],{
        // options
        cellAlign: 'center',
        contain: true,
        pageDots: false,
        wrapAround: true,
        arrowShape: 'm67.37 100-50-50 50-50 15.26 15.25-34.75 34.75 34.75 34.75z'
      });
      
    updateSliderCount(slider, flkty);

});



     

    
 





